<template>
<div id="ServiceCodeGRPSpecRateAddEdit"> 
<form> 
<div class="form-group row my-1">
    <label for="SpecialistAmount" class="col-sm-4 label-small my-0">Specialist Code:</label>
        <div class="col-sm-8 my-0">
            <select  id="ServiceType"  v-model="code" class="mb-1 form-control form-control-sm"> 
                <option v-for="option  in lookup" v-bind:value="{id: option.id, text: option.text, type:option.type}" :key="option.id" class="small">
                    {{ option.text }} ({{option.type}})
                </option> 
            </select>
        </div>
    <!-- <div  class="col-sm-4" v-show="$v.emailaddress.$error"> -->

    <!-- </div> -->
</div>
<div class="row"  v-show="$v.code.$error">
    <div class="col-sm-4" >
           
    </div>
    <div class="col-sm-8" >
     <small class="sml-red ml-3" v-if="!$v.code.Duplicate">Specialist Code already added</small>
     </div> 
</div> 
<div class="form-group row my-1">
    <label for="SpecialistAmount" class="col-sm-4 label-small my-0">Specialist Amount:</label>
        <div class="col-sm-8 my-0">
        <input id="SpecialistAmount"   maxlength="9" v-model="amtChargeSpec" placeholder="Specialist Amount" class="mb-0 form-control form-control-xs">
    </div>
    <!-- <div  class="col-sm-4" v-show="$v.emailaddress.$error"> -->
    <!-- <div class="row" > -->
        <!-- <small class="sml-red" v-if="!$v.emailaddress.required">Email is required</!--> 
        <!-- <small class="sml-red" v-if="!$v.emailaddress.email">Email is invalid</small> -->
        <!-- </div>  -->
    <!-- </div> -->
</div> 
<div class="row" v-show="$v.amtChargeSpec.$error" > 
    <div class="col-sm-4" >
           
    </div>
    <div class="col-sm-8" >
        <small class="sml-red ml-3" v-if="!$v.amtChargeSpec.required">Specialist Amount is required</small>
        <small class="sml-red ml-3" v-if="!$v.amtChargeSpec.SixvTwo && $v.amtChargeSpec.required">Specialist Amount can have upto 2 decimals and maximum value of 999,999.99</small>
    </div> 
</div> 
<hr>
<div class="row" >
    <div class="col-sm-8" >
            <button v-on:click="SavePopup" :disabled="disableSave" type="button" class="btn BtnSave  btn-sml"><i :class="saveIcon"></i> {{btnName}} </button>
    </div>
    <div class="col-sm-4">
        <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
    </div>
</div> 
</form>
</div>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'
const SixvTwo = helpers.regex('alphaNum', /^\d{0,6}(\.\d{1,2})?$/)

Vue.use(Vuelidate)
import { required, minLength, maxLength, between,withParams,email,numeric} from 'vuelidate/lib/validators'
import { notEqual } from 'assert'; 
export default {
    props:{
        UserData:'',
        mode:'',
        LookUp:'',
        DataSet:'',
        UserRow:'',
    },
  data: function(){
    return{
        saveIcon:'fas fa-plus',
        btnName: 'Add Max Specialist Amount',
        amtChargeSpec:'',
        codeSpecType:'',
        succeeded:true,
        showModal:false,
        //PayType:[['id']='E',['text']='Electronic'],[['id']='C',['text']='Cheque']]
        showModal:false,
        Msg:'',
        EditMode:'',
        disableSave:false,
        updateRow:{
          codeSpecType:'',
          amtChargeSpec:'',
          desc:'',
        },
        lookup:[],
        code:'',
        tabledata:'',
        editedRow:''
    }   
  },
  created: function(){
      this.EditMode = this.mode;
      if(this.EditMode  == 'Edit')
      {
          this.btnName = 'Edit Max Specialist Amount';
          this.saveIcon = 'far fa-edit'; 
      } 
      this.codeSpecType = this.UserData.codeSpecType;
      this.amtChargeSpec = this.UserData.amtChargeSpec;
      this.tabledata = this.DataSet;
      this.editedRow = this.UserRow;
      // console.log("LookUp = " + this.LookUp);
     // console.log((this.tabledata.findIndex(x=>x.codeSpecType == this.codeSpecType))); 
      this.lookup = this.LookUp; 
      this.code = this.codeSpecType==undefined? this.lookup[0]:this.lookup.find(x=>x.type == this.codeSpecType);

  },





methods: {
  ClosePopup: function() {     
      this.$root.$emit('bv::hide::modal', 'ServiceCodeGRPSpecRateAddEdit', '#btnShow') 
         //this.$v.$reset();
    },
    SavePopup: function(){
        // console.log(this.type);
        // console.log(this.tabledata);
       this.$v.$touch();

      if (!this.$v.$invalid){
        //  alert(this.code.type);

          this.updateRow.codeSpecType = this.code.type;
          this.updateRow.amtChargeSpec =this.amtChargeSpec;
          this.updateRow.desc = this.code.text;
          console.log(this.updateRow);
          this.$emit('GRPSpecRateUpdate', this.updateRow)
          this.showModal=false;
      }

      
    },

    // GRPSpecRateExit: function(){
    //     this.showModal=false;
    //       if(this.succeeded){
    //        this.$emit('GRPSpecRateExit');
    // }
    // }
},
  validations(){
    return {
        amtChargeSpec:{
            required,
            SixvTwo,
        },
        code:{
               Duplicate: value=> this.tabledata.findIndex(x=>x.codeSpecType == this.code.type)== -1 || this.tabledata.findIndex(x=>x.codeSpecType == this.code.type) == this.editedRow
        }
    }
  }
}
</script>

<style>

</style>
